import React from 'react';
import { Document, Font, Image, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import LatoRegular from "../../utils/fonts/Lato-Regular.ttf";
import LatoBold from '../../utils/fonts/Lato-Bold.ttf';
import moment from 'moment';
import { formatNumber } from '../../utils/Utils';

Font.register({
 family: 'Lato',
 fonts: [{ src: LatoRegular }, { src: LatoBold, fontWeight: 'bold' }]
});

const DispatchPDF = ({ dispatch_details, order_details, tenant_info }) => {

 let products = dispatch_details?.products?.map((item) => {

  const product_value = order_details?.order_items?.find((search_item) => search_item?.size === item?.size && search_item?.product_id === item?.product_id && search_item?.color === item?.color);

  if (product_value === null)
  {
   return { ...item };
  }
  else
  {
   return { ...item, unit_value: product_value?.unit_value, total_value: product_value?.total_value };
  }
 }
 );
 let totalUnits = products.reduce((sum, item) => sum + (item.units || 0), 0);

 const styles = StyleSheet.create({
  page: {
   padding: 20,
   paddingBottom: 60, // Added bottom padding for footer
   fontFamily: "Lato",
   fontSize: 9, // Reduced base font size
   lineHeight: 1.2 // Tighter line height
  },
  header: {
   flexDirection: 'row',
   alignItems: 'flex-start',
   justifyContent: 'space-between',
   marginBottom: 15,
   borderBottom: '1px solid #e1e1e1',
   paddingBottom: 15
  },
  logoContainer: {
   flex: 1
  },
  logo: {
   width: "auto",
   height: 60
  },
  titleContainer: {
   flex: 2,
   textAlign: 'center',
   paddingTop: 10
  },
  companyName: {
   fontSize: 16,
   fontWeight: "bold",
   color: '#2c3e50'
  },
  documentTitle: {
   fontSize: 14,
   fontWeight: "semibold",
   marginTop: 10,
   color: '#3498db'
  },
  infoContainer: {
   flex: 1,
   textAlign: 'right'
  },
  infoText: {
   fontSize: 8,
   color: '#7f8c8d',
   marginBottom: 2
  },
  detailsContainer: {
   borderWidth: 1,
   borderColor: "#ccc",
   borderRadius: 5,
   padding: 10,
   marginBottom: 15,
   backgroundColor: '#f8f9fa'
  },
  detailsTitle: {
   fontSize: 12,
   fontWeight: "bold",
   marginBottom: 8,
   color: '#2c3e50'
  },
  detailsGrid: {
   flexDirection: "row",
   flexWrap: "wrap"
  },
  detailItem: {
   width: "33.33%", // 3 columns instead of 2 for landscape
   flexDirection: "row",
   marginBottom: 6
  },
  detailLabel: {
   fontWeight: "bold",
   fontSize: 9,
   width: "40%",
   marginRight: 5,
   color: '#7f8c8d'
  },
  detailValue: {
   fontSize: 9,
   width: "60%",
   color: '#2c3e50'
  },
  table: {
   borderWidth: 1,
   borderColor: "#A9A9A9",
   borderRadius: 5,
   overflow: "hidden",
   marginBottom: 15
  },
  tableHeader: {
   flexDirection: "row",
   backgroundColor: "#3498db",
   padding: 5
  },
  headerCell: {
   width: "16.6%",
   textAlign: "center",
   fontWeight: "bold",
   fontSize: 9,
   color: 'white'
  },
  tableRow: {
   flexDirection: "row",
   borderBottomWidth: 1,
   borderColor: "#A9A9A9",
   padding: 5,
   minHeight: 20
  },
  rowCell: {
   width: "16.6%",
   textAlign: "center",
   fontSize: 9
  },
  totalRow: {
   flexDirection: "row",
   backgroundColor: "#f0f0f0",
   padding: 5,
   borderTopWidth: 1,
   borderColor: "#A9A9A9"
  },
  totalLabel: {
   width: "66.67%",
   textAlign: "right",
   fontWeight: "bold",
   fontSize: 10
  },
  totalValue: {
   width: "16.67%",
   textAlign: "center",
   fontWeight: "bold",
   fontSize: 10
  },
  commentSection: {
   marginTop: 15
  },
  commentTitle: {
   fontSize: 10,
   fontWeight: "bold",
   marginBottom: 5,
   color: '#2c3e50'
  },
  commentBox: {
   borderWidth: 1,
   borderColor: "#A9A9A9",
   padding: 8,
   height: 50
  },
  signatures: {
   flexDirection: "row",
   marginTop: 15
  },
  signatureBox: {
   width: "50%"
  },
  signatureLabel: {
   fontSize: 10,
   fontWeight: "bold",
   marginBottom: 5,
   color: '#2c3e50'
  },
  signatureLine: {
   borderTopWidth: 1,
   borderBottomWidth: 1,
   borderColor: "#000",
   width: "80%",
   marginTop: 10
  },
  signatureText: {
   fontSize: 9,
   textAlign: "center",
   marginTop: 3
  },
  footer: {
   position: 'absolute',
   bottom: 20,
   left: 20,
   right: 20,
   textAlign: "center",
   fontSize: 8,
   color: '#95a5a6',
   paddingTop: 8,
   borderTop: '1px solid #eee'
  },
  pageNumber: {
   position: 'absolute',
   bottom: 22,
   right: 20,
   fontSize: 8,
   color: '#95a5a6'
  }
 });

 const dispatchDetails = [
  { label: "Destination:", value: order_details?.order_name },
  { label: "Sales Representative:", value: order_details?.sales_rep?.name },
  { label: "Order Ref No:", value: order_details?.order_ref_number },
  { label: "Dispatch Ref No:", value: dispatch_details?.dispatch_ref_no },
  { label: "Truck Driver:", value: dispatch_details?.truck_driver_name },
  { label: "Transporter:", value: dispatch_details?.transporter_name },
  { label: "Truck License Plate:", value: dispatch_details?.truck_licence_plate },
  { label: "Trailer One:", value: dispatch_details?.trailer_one },
  { label: "Trailer Two:", value: dispatch_details?.trailer_two },
  { label: "Dispatch Date & Time:", value: dispatch_details?.dispatch_date_time ? moment(dispatch_details?.dispatch_date_time).format("YYYY-MM-DD HH:mm:ss") : "" },
 ];

 return (
  <Document title={dispatch_details?.dispatch_ref_no ? `Dispatch ${dispatch_details?.dispatch_ref_no}` : "Dispatch"}>
   <Page size="A4" orientation="landscape" style={styles.page} wrap>
    {/* Header */}
    <View style={styles.header} fixed>
     <View style={styles.logoContainer}>
      {tenant_info?.tenant_logo && <Image style={styles.logo} src={tenant_info?.tenant_logo} />}
     </View>

     <View style={styles.titleContainer}>
      <Text style={styles.companyName}>{tenant_info?.name}</Text>
      <Text style={styles.documentTitle}>Dispatch Note</Text>
     </View>

     <View style={styles.infoContainer}>
      <Text style={styles.infoText}>Date: {new Date().toLocaleDateString()}</Text>
      <Text style={styles.infoText}>Ref: {dispatch_details?.dispatch_ref_no || "--"}</Text>
     </View>
    </View>

    {/* Dispatch Details */}
    <View style={styles.detailsContainer} fixed>
     <Text style={styles.detailsTitle}>Dispatch Details</Text>
     <View style={styles.detailsGrid}>
      {dispatchDetails.map((item, index) => (
       <View key={index} style={styles.detailItem}>
        <Text style={styles.detailLabel}>{item.label}</Text>
        <Text style={styles.detailValue}>{item.value || "--"}</Text>
       </View>
      ))}
     </View>
    </View>

    {/* Products Table */}
    {products.length > 0 && (
     <View style={styles.table}>
      {/* Table Header */}
      <View style={styles.tableHeader}>
       {["Category", "Name", "Color", "Size", "Units", "Unit Value (ZMW)", "Total Value (ZMW)", "No. Received"].map((header, index) => (
        <Text key={index} style={styles.headerCell}>{header}</Text>
       ))}
      </View>

      {/* Table Rows */}
      {products.map((item, index) => (
       <View key={index} style={[styles.tableRow, { backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa' }]}>
        {[
         item.category,
         item.name,
         item.color,
         item.size,
         item.units,
         formatNumber(item.unit_value),
         formatNumber(item.total_value)
        ].map((value, i) => (
         <Text key={i} style={styles.rowCell}>
          {value || "--"}
         </Text>
        ))}
        {/* "No Received" Column */}
        <Text style={styles.rowCell}>________</Text>
       </View>
      ))}

      {/* Total Row */}
      <View style={styles.totalRow}>
       <Text style={styles.totalLabel}>Total:</Text>
       <Text style={styles.totalValue}>{totalUnits}</Text>
       <Text style={styles.totalValue}>________</Text>
      </View>
     </View>
    )}

    {/* Comment Box */}
    <View style={styles.commentSection}>
     <Text style={styles.commentTitle}>Comments:</Text>
     <View style={styles.commentBox}></View>
    </View>

    {/* Signatures Section */}
    <View style={styles.signatures}>
     {/* Sales Representative */}
     <View style={styles.signatureBox}>
      <Text style={styles.signatureLabel}>Sales Representative:</Text>
      <View style={styles.signatureLine} />
      <Text style={styles.signatureText}>Signature</Text>
     </View>

     {/* Customer */}
     <View style={styles.signatureBox}>
      <Text style={styles.signatureLabel}>Customer's Signature/Stamp:</Text>
      <View style={styles.signatureLine} />
      <Text style={styles.signatureText}>Signature/Stamp</Text>
     </View>
    </View>

    {/* Footer */}
    <View style={styles.footer} fixed>
     <Text>Generated on {moment().format("YYYY-MM-DD HH:mm")} | Dispatch Ref No: {dispatch_details?.dispatch_ref_no || "--"}</Text>
    </View>

    {/* Page Number */}
    <Text
     style={styles.pageNumber}
     render={({ pageNumber, totalPages }) => (
      `Page ${pageNumber} of ${totalPages}`
     )}
     fixed
    />
   </Page>
  </Document>
 );
};

export default DispatchPDF;